module.exports = __webpack_public_path__ + "img/icon_5_17.b645ddf0.png";